import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const TabModuleHead = ({ tabContent, changeTabContent, adContent }) => {
    const clickTabHandle = (tabIndex) => {
        const tabContentNew = tabContent.map((item, index) => {
            const active = tabIndex === index;

            return {
                ...item,
                active,
            };
        });

        changeTabContent(tabContentNew);
    };

    return (
        <div className={styles.tabModuleHead}>
            {tabContent.map((item, index) => {
                return (
                    <div
                        key={index}
                        className={styles.item}
                        onClick={() => {
                            clickTabHandle(index);
                        }}>
                        <div className={`${styles.title} ${item.active ? styles.active : ''}`}>{item.name}</div>
                        {tabContent.length - 1 !== index && <div className={styles.line} />}
                    </div>
                );
            })}
            {adContent?.adPic && (
                <a href={adContent?.adUrl || ''} target="_blank">
                    <img className={styles.zggd} src={adContent?.adPic} />
                </a>
            )}
        </div>
    );
};

TabModuleHead.propTypes = {
    tabContent: PropTypes.array,
    changeTabContent: PropTypes.func,
    adContent: PropTypes.object,
};

export default errorBoundary(TabModuleHead);
